import { Stack, Typography } from '@mui/material';
import React from 'react';

interface KeyboardShortcutProps {
	title?: string;
	shortcut: string[];
}

const KeyboardShortcut = (props: KeyboardShortcutProps) => {
	return (
		<Stack direction='row' spacing={1}>
			<Typography variant='caption'>{props.title}</Typography>
			{props.shortcut.map((shortcut, index) => (
				<Typography
					key={index}
					variant='caption'
					sx={{
						backgroundColor: 'black.darker',
						color: 'white.lightest',
						padding: '0px 8px',
					}}
				>
					{shortcut}
				</Typography>
			))}
		</Stack>
	);
};

export default KeyboardShortcut;
